import { AppDispatch } from "../../../store";
import { ensureCustomer } from "../../../redux/modules/customers/reducer";
import { ensureSite } from "../../../redux/modules/sites/actions";
import { ensureAcl } from "../../../acl/asyncActions";
import { loadWorkflows } from "../../../redux/modules/workflow/actions";

export const userOpensWorkflowListPage =
  (customerId: string, siteId: string, workflowType: string) =>
  async (dispatch: AppDispatch): Promise<void> => {
    await Promise.all([
      dispatch(ensureCustomer(customerId)),
      dispatch(ensureSite(customerId, siteId)),
      dispatch(ensureAcl(customerId, siteId)),
      dispatch(loadWorkflows(customerId, siteId, workflowType)),
    ]);
  };
